import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications, readNotification } from "../../redux/actions/notificationActions";
import { useNavigate } from "react-router-dom";
import { setActiveAppelOffre, setActiveDonneurOrdre, setActivePrestataire, setActiveProjet, setActiveRole, setActiveSection, setActiveTabAppelOffre, setActiveTabMatch, setActiveTabMatchAppelOffre, setActiveTabProjet } from "../../redux/actions/dashboardActions";
import { fetchMatches, fetchMatchesDonneurOrdre, fetchMessages, selectMatch, selectMatchDonneurOrdre } from "../../redux/actions/matchActions";
import { fetchLikesReceived } from "../../redux/actions/likeActions";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import { setSelectedProposition } from "../../redux/actions/propositionActions";

const NotificationsDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, user } = useSelector((state) => state.auth);
    const userRole = user?.rolesUser?.[0]?.roleUser;

    const notifications = useSelector((state) => state.notification.list);
    const matchs = useSelector((state) => state.match.list);
    const matchesDonneurOrdre = useSelector((state) => state.match.matchesDonneurOrdre);

    useEffect(() => {
        if (token) {
            dispatch(fetchNotifications(token));
        }
    }, [dispatch, token]);


    /**
     * Texte affiché selon typeNotif
     */
    const formatNotifText = (notif) => {
        switch (notif.type) {

            case "new_message":
                return userRole === "prestataire" ? "Nouveau message reçu de " + notif.data.prenomClient + " pour le projet " + notif.data.titreProjet : "Nouveau message reçu de " + notif.data.raisonSocialePrestataire + " pour votre projet " + notif.data.titreProjet;
            case "new_message_proposal_accepted":
                return userRole === "prestataire" ? "Nouveau message reçu de " + notif.data.prenomClient + " pour le projet " + notif.data.titreProjet : "Nouveau message reçu de " + notif.data.raisonSocialePrestataire + " pour votre projet " + notif.data.titreProjet;

            case "new_message_donneur_ordre":
                return userRole === "prestataire" ? "Nouveau message reçu de " + notif.data.raisonSocialeDonneurOrdre + " pour l'appel d'offres " + notif.data.titreProjet : "Nouveau message reçu de " + notif.data.raisonSocialePrestataire + " pour votre appel d'offre " + notif.data.titreProjet;

            case "new_like_receive":
                return userRole === "prestataire" ? "Nouveau like reçu de " + notif.data.prenomClient + " pour le projet " + notif.data.titreProjet : "Nouveau like reçu de " + notif.data.raisonSocialePrestataire + " pour votre projet " + notif.data.titreProjet;

            case "new_match":
                return userRole === "prestataire" ? "Nouveau match reçu de " + notif.data.prenomClient + " pour le projet " + notif.data.titreProjet : "Nouveau match reçu de " + notif.data.raisonSocialePrestataire + " pour votre projet " + notif.data.titreProjet;
            case "new_inscription_prestataire":
                return notif.data.message;
            case "new_inscription_client":
                return notif.data.message;
            case "new_inscription_donneur_ordre":
                return notif.data.message;
            case "new_projet_client":
                return notif.data.message;
            case "project_refused":
                return notif.data.message;
            case "project_canceled":
                return notif.data.message;
            case "new_proposition":
                return notif.data.message;
            
            case "proposition_declined":
                return notif.data.message;

            case "proposition_accepted":
                return notif.data.message;

            case "profil_presta_verified":
                return notif.data.message;
            
            case "new_prestataire_verif":
                return notif.data.message;
            
            case "new_pending_intervention":
                return notif.data.message;
            
            case "new_accepted_intervention":
                return notif.data.message;
            
            case "new_finish_intervention":
                return notif.data.message;

            case "system":
                return notif.data.text || "Notification système";

            default:
                return notif.data.message || "Nouvelle notification";
        }
    };


    /**
     * Action bouton "Consulter"
     */
    const handleConsult = (notif) => {
        switch (notif.type) {

            case "new_message":
                dispatch(setActiveTabMatch("chat"));
                userRole==="prestataire"?dispatch(setActiveTabProjet("confirmes")):dispatch(setActiveTabProjet("matchs"));
                const match = matchs.find(m => m.id === notif.data.matchId);
                const projet = match.projet;
                dispatch(selectMatch(match));
                dispatch(setActiveProjet(projet));
                dispatch(setActiveSection("projets"));
                break;
            case "new_message_proposal_accepted":
                dispatch(setActiveTabMatch("chat"));
                dispatch(setActiveTabProjet("prestaSelected"));
                dispatch(setSelectedProposition(notif.data.proposition));
                dispatch(fetchMessages(token,notif.data.proposition.match.id))
                dispatch(setActiveProjet(notif.data.proposition.projet));
                dispatch(setActiveSection("projets"));
                break;
            case "new_message_donneur_ordre":
                dispatch(setActiveTabMatchAppelOffre("chat"));
                userRole==="prestataire"?dispatch(setActiveTabAppelOffre("confirmes")):dispatch(setActiveTabAppelOffre("matchs"));
                const matchDonneurOrdre = matchesDonneurOrdre.find(m => m.id === notif.data.matchId);
                console.log(matchesDonneurOrdre);
                const appelOffre = matchDonneurOrdre.projet;

                dispatch(selectMatchDonneurOrdre(matchDonneurOrdre));
                dispatch(setActiveAppelOffre(appelOffre));
                dispatch(setActiveSection("appelOffre"));
                break;

            case "new_inscription_prestataire":
                dispatch(setActiveSection("clients"));
                dispatch(setActiveRole("prestataire"));
                dispatch(setActivePrestataire(notif.data.newPrestataire.idUser));
                break;
            
            case "new_inscription_client":
                dispatch(setActiveSection("clients"));
                dispatch(setActiveRole("client"));
                dispatch(setActivePrestataire(notif.data.newClient.idUser));
                break;

            case "new_inscription_donneur_ordre":
                dispatch(setActiveSection("clients"));
                dispatch(setActiveRole("donneur_ordre"));
                dispatch(setActiveDonneurOrdre(notif.data.newDonneurOrdre.idUser));
                break;

            case "new_projet_client":
                dispatch(setActiveSection("projetsClients"));
                break;
            
            case "new_like_received":
                break;

            case "new_match":
                break;

            case "profil_presta_verified":
                break;

            case "new_prestataire_verif":
                dispatch(setActiveSection("prestatairesToValidate"));
                break;
            case "system":
                // peut-être un lien système
                break;

            default:
                break;
        }

        // on marque la notif comme lue
        dispatch(readNotification(token, notif.id));
    };


    /**
     * Action bouton "OK"
     */
    const handleOk = (notif) => {
        dispatch(readNotification(token, notif.id));
    };


    return (
        <div style={{ padding: "20px" }}>
            <h2>Notifications</h2>

            {notifications.length === 0 && (
                <p>Aucune notification non lue.</p>
            )}

            <ul style={{ listStyle: "none", padding: 0 }}>
                {notifications.map((notif) => (
                    <li
                        key={notif.id}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "15px",
                            marginBottom: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <strong>{formatNotifText(notif)}</strong>
                            <br />
                            <small style={{ color: "#777" }}>
                                {new Date(notif.createdAt).toLocaleString()}
                            </small>
                        </div>

                        <div style={{ display: "flex", gap: "10px" }}>
                            <button
                                style={{ padding: "6px 10px" }}
                                onClick={() => handleOk(notif)}
                            >
                                OK
                            </button>

                            <button
                                style={{ padding: "6px 10px" }}
                                onClick={() => handleConsult(notif)}
                            >
                                Consulter
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NotificationsDashboard;
